import {
  ActionCard,
  Container,
  Page,
} from '@foxtrotplatform/developer-platform-common-ui-component-lib';
import { FunctionComponent } from 'react';

import assetDownloadIcon from '../../../common/assets/svg/asset-download-icon.svg';
import documentationIcon from '../../../common/assets/svg/documentation-icon.svg';
import { OrganizationTenantInfo } from '../OrganizationDetails';

export const OrganizationProvisioning: FunctionComponent =
  (): JSX.Element | null => {
    return (
      <Page>
        <Container size="medium">
          <OrganizationTenantInfo />
          <div className="flex flex-wrap justify-evenly mt-os1-spacing gap-y-4">
            <ActionCard
              actionTitle="Learn More"
              description="Learn about the Core APIs"
              direction="HORIZONTAL"
              iconSource={documentationIcon}
              isLinkButton={true}
              onActionClick={() =>
                window.open('https://docs.getos1.com/overview-2')
              }
              title="Core APIs"
            />
            <ActionCard
              actionTitle="Learn More"
              description="Learn about the Logistics Framework"
              direction="HORIZONTAL"
              iconSource={documentationIcon}
              isLinkButton={true}
              onActionClick={() =>
                window.open('https://docs.getos1.com/overview-1')
              }
              title="Logistics Framework"
            />
            <ActionCard
              actionTitle="Learn More"
              description="Learn about our UI guidelines"
              direction="HORIZONTAL"
              iconSource={documentationIcon}
              isLinkButton={true}
              onActionClick={() =>
                window.open('https://docs.getos1.com/ui-guidelines')
              }
              title="UI Guidelines"
            />
            <ActionCard
              actionTitle="Download SDKs"
              description="View available SDK packages"
              direction="HORIZONTAL"
              iconSource={assetDownloadIcon}
              isLinkButton={true}
              onActionClick={() =>
                window.open('https://docs.getos1.com/sdk-overview')
              }
              title="SDKs"
            />
          </div>
        </Container>
      </Page>
    );
  };
